import React from 'react';
import { StyleSheet, View } from 'react-native';
import ContentLoader, { Rect } from 'react-content-loader/native';
import { useTheme } from '@/context/ThemeContext';

export default function ListItemPlaceholder() {
  const { colors } = useTheme();

  const styles = StyleSheet.create({
    listItem: {
      flexDirection: 'row',
      gap: 12,
      paddingVertical: 12,
      height: 73,
      width: '100%',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
  });

  return (
    <View style={styles.listItem}>
      <ContentLoader
        speed={2}
        width={320}
        height={60}
        viewBox="0 0 320 60"
        backgroundColor={colors.solid_color_tertiary}
        foregroundColor={colors.border_color_secondary}
      >
        <Rect x="0" y="0" rx="24" ry="24" width="48" height="48" /> 
        <Rect x="65" y="3" rx="2" ry="2" width="158" height="18" /> 
        <Rect x="64" y="30" rx="0" ry="0" width="236" height="12" />
      </ContentLoader>
    </View>
  );
}
